import React, { Fragment } from 'react';

import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { PayStationCashLevelsFormSchemaValues } from 'src/features/payment/api/useChangeCoinBanknoteAvailability';
import { paymentsMessages } from 'src/features/payment/utils/messages';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';

type ChangeCashLevelsFormProps = {
    form: UseFormReturn<PayStationCashLevelsFormSchemaValues>;
    onSubmit: (values: PayStationCashLevelsFormSchemaValues) => void;
};
enum NOMINAL_NAME {
    COINS = 'coins',
    BANKNOTES = 'banknotes',
}
function ChangeCashLevelsForm({ onSubmit, form }: ChangeCashLevelsFormProps) {
    const { formatMessage } = useIntl();

    const { coins, banknotes } = form.watch();

    const { nominalMap } = React.useMemo(() => {
        return {
            nominalMap: [
                {
                    value: coins,
                    name: NOMINAL_NAME.COINS,
                    label: formatMessage(paymentsMessages.coins),
                },
                {
                    value: banknotes,
                    name: NOMINAL_NAME.BANKNOTES,
                    label: formatMessage(paymentsMessages.banknotes),
                },
            ],
        };
    }, [formatMessage, coins, banknotes]);

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            {nominalMap.map(({ value, name }) => {
                return (
                    <Fragment key={name}>
                        {value.map((_, index) => (
                            <Fragment key={index}>
                                <InputFormField<PayStationCashLevelsFormSchemaValues>
                                    form={form}
                                    name={`${name}.${index}.count`}
                                    label={`${value[index].value} ${value[index].currency}`}
                                    placeholder={`${formatMessage(paymentsMessages.count)}...`}
                                    type="number"
                                    min={0}
                                />
                            </Fragment>
                        ))}
                    </Fragment>
                );
            })}
        </Form>
    );
}

export default ChangeCashLevelsForm;
